import React, { useEffect } from "react";
import { usePohrebka2 } from "../../context/Pohrebka2Context";

const cardStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 24,
  padding: 24,
  boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 14,
  fontWeight: 700,
  color: "#111827",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 14,
  border: "1px solid #d1d5db",
  fontSize: 15,
  background: "#fff",
  outline: "none",
  boxSizing: "border-box",
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 120,
  resize: "vertical",
};

export default function Pohrebka2VstupniForm() {
  const { order, patchSection, setOrder, activeOrderId } = usePohrebka2();
  const vstupni = order?.vstupniInformace || {};

  useEffect(() => {
    const handler = (e) => {
      const full = String(e?.detail?.zesnuly || "").trim();
      if (!full) return;

      const parts = full.split(/\s+/).filter(Boolean);
      const jmenoZesnuleho = parts.shift() || "";
      const prijmeniZesnuleho = parts.join(" ");

      patchSection("vstupniInformace", {
        ...(jmenoZesnuleho ? { jmenoZesnuleho } : {}),
        ...(prijmeniZesnuleho ? { prijmeniZesnuleho } : {}),
      });
    };

    window.addEventListener("pohrebka2-calendar-create-date", handler);
    return () => window.removeEventListener("pohrebka2-calendar-create-date", handler);
  }, [patchSection]);

  const setField = (name, value) => {
    const val = String(value || "");

    setOrder((prev) => {
      const base = prev || {};
      const currentVstupni = base.vstupniInformace || {};
      const currentZesnula = base.zesnulaOsoba || {};
      const currentPrevoz = base.prevoz || {};
      const currentZaklad = base.zaklad || {};

      const nextVstupni = {
        ...currentVstupni,
        [name]: val,
      };

      const nextZesnula = {
        ...currentZesnula,
      };

      const nextPrevoz = {
        ...currentPrevoz,
      };

      const nextZaklad = {
        ...currentZaklad,
      };

      if (name === "datumUmrti" || name === "casUmrti" || name === "mistoUmrti" || name === "adresaUmrti") {
        if (name === "datumUmrti") nextZesnula.datumUmrti = val;
        if (name === "casUmrti") nextZesnula.casUmrti = val;
        if (name === "mistoUmrti") nextZesnula.mistoUmrti = val;
        if (name === "adresaUmrti") nextZesnula.adresaUmrti = val;

        if (name === "mistoUmrti") nextPrevoz.mistoOdvozu = val;
        if (name === "adresaUmrti") nextPrevoz.adresaOdvozu = val;
      }

      if (name === "jmenoZesnuleho" || name === "prijmeniZesnuleho" || name === "rodneCislo" || name === "datumNarozeni") {
        if (name === "jmenoZesnuleho") nextZesnula.jmeno = val;
        if (name === "prijmeniZesnuleho") nextZesnula.prijmeni = val;
        if (name === "rodneCislo") nextZesnula.rodneCislo = val;
        if (name === "datumNarozeni") nextZesnula.datumNarozeni = val;
      }

      const fullName = [
        nextVstupni.jmenoZesnuleho || nextZesnula.jmeno || "",
        nextVstupni.prijmeniZesnuleho || nextZesnula.prijmeni || "",
      ].filter(Boolean).join(" ").trim();

      if (fullName) {
        nextZaklad.zesnuly = fullName;
      }

      if (String(nextZaklad.typZakazky || "").trim() === "vyjezd" && !String(nextZaklad.datumSjednani || "").trim()) {
        nextZaklad.datumSjednani = String(nextVstupni.datumUmrti || "").trim();
      }

      return {
        ...base,
        vstupniInformace: nextVstupni,
        zesnulaOsoba: nextZesnula,
        prevoz: nextPrevoz,
        zaklad: nextZaklad,
      };
    });
  };

  return (
    <div style={cardStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 34, fontWeight: 900, color: "#111827", lineHeight: 1.05 }}>Vstupní informace</div>
          <div style={{ marginTop: 8, color: "#6b7280", fontSize: 16 }}>
            Základní údaje o zesnulém a okolnostech úmrtí.
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 14, color: "#6b7280", fontWeight: 700 }}>Aktivní zakázka</div>
          <div style={{ fontSize: 28, fontWeight: 900, color: "#111827" }}>{activeOrderId || "-"}</div>
        </div>
      </div>

      <div style={gridStyle}>
        <div>
          <label style={labelStyle}>Jméno zesnulého</label>
          <input
            type="text"
            value={vstupni.jmenoZesnuleho || ""}
            onChange={(e) => setField("jmenoZesnuleho", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Příjmení zesnulého</label>
          <input
            type="text"
            value={vstupni.prijmeniZesnuleho || ""}
            onChange={(e) => setField("prijmeniZesnuleho", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Rodné číslo</label>
          <input
            type="text"
            value={vstupni.rodneCislo || ""}
            onChange={(e) => setField("rodneCislo", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Datum narození</label>
          <input
            type="date"
            value={vstupni.datumNarozeni || ""}
            onChange={(e) => setField("datumNarozeni", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Datum úmrtí</label>
          <input
            type="date"
            value={vstupni.datumUmrti || ""}
            onChange={(e) => setField("datumUmrti", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Čas úmrtí</label>
          <input
            type="time"
            value={vstupni.casUmrti || ""}
            onChange={(e) => setField("casUmrti", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Místo úmrtí</label>
          <input
            type="text"
            value={vstupni.mistoUmrti || ""}
            onChange={(e) => setField("mistoUmrti", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Adresa úmrtí</label>
          <input
            type="text"
            value={vstupni.adresaUmrti || ""}
            onChange={(e) => setField("adresaUmrti", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Pitevna</label>
          <input
            type="text"
            value={vstupni.pitevna || ""}
            onChange={(e) => setField("pitevna", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <label style={labelStyle}>Lékař</label>
          <input
            type="text"
            value={vstupni.lekarJmeno || ""}
            onChange={(e) => setField("lekarJmeno", e.target.value)}
            style={inputStyle}
          />
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        <label style={labelStyle}>Poznámka</label>
        <textarea
          value={vstupni.poznamka || ""}
          onChange={(e) => setField("poznamka", e.target.value)}
          style={textareaStyle}
        />
      </div>
    </div>
  );
}
